export enum TransactionStatus {
  OK = 'OK',
  PENDING = 'PENDING',
  NEW = 'NEW',
  SENT = 'SENT',
  NOTIFIED = 'NOTIFIED',
  WAITING = 'WAITING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  BEFORE_SEND = 'BEFORE_SEND',
  USED = 'USED',
  CREATED = 'CREATED',
  VERIFIED = 'VERIFIED',
}
